module.exports = __webpack_public_path__ + "8e65be386473ee6216597d002682623d.jpg";